hrd.GeolocationMap = hrd.AbstractCommonInterface.extend({
	/** @type JQuery */
	$field: null,
	/** @type  google.maps.Map */
	map: null,
	/** @type  google.maps.Marker */
	marker: null,

	init: function($field, options) {
		this.prepareField($field, options)
			.then(() => this.initMap(options))
			.then((map, marker) => {
				this.map = map;
				this.marker = marker;
			});
	},
	prepareField: function($field, options) {
		let promise;
		this.$field = $field;
		if (!window.google) {
			this.$field
				.closest('.field-composite')
				.remove();
			promise = $.never();
		} else {
			this.$field.addClass('do-not-touch-inner-buttons');
			promise = $.when();
		}
		return promise;
	},
	initMap: function(options) {
		return initGeolocationMap(this.$field.get(0), options);
	},
	getLocation: function() {
		if (!this.map || !this.marker) return;

		const center = this.map.getCenter();

		return { lat: center.lat(), lng: center.lng() };
	},
	calculateLocation: function(locations) {
		const deferred = $.Deferred();

		if(!locations || locations.length <= 0) {
			deferred.resolve();
			return deferred.promise();
		}

		const temp = [];
		let geocoder = null;
		let usingGeocoder = false;
		const useCoordinates = (location) => {
			const lat = parseFloat(location.lat);
			const lng = parseFloat(location.lng);

			return typeof lat !== 'undefined' && !isNaN(lat) && typeof lng !== 'undefined' && !isNaN(lng);
		};
		const useGeocoder = (location) => {
			return (typeof location.address === 'string' && location.address) || (typeof location.geoAddress === 'string' && location.geoAddress);
		};

		if(!useCoordinates(locations[0]) && useGeocoder(locations[0])) {
			geocoder = new google.maps.Geocoder();
			usingGeocoder = true;
		}

		locations.forEach((location) => {
			if(useCoordinates(location)) {
				const lat = parseFloat(location.lat);
				const lng = parseFloat(location.lng);
				const marker = new google.maps.Marker({
					position: { lat, lng },
				});
				this.markers.push(marker);
				temp.push(location);
			} else if(useGeocoder(location)) {
				if(!geocoder) {
					geocoder = new google.maps.Geocoder();
					usingGeocoder = true;
				}

				const address = location.geoAddress || location.address;

				geocoder.geocode({
					address
				}, (results, status) => {
					if (status == google.maps.GeocoderStatus.OK) {
						const lat = results[0].geometry.location.lat();
						const lng = results[0].geometry.location.lng();
						const marker = new google.maps.Marker({
							position: { lat, lng },
						});

						this.markers.push(marker);
					}

					temp.push(location);

					if(locations.length === temp.length) {
						setTimeout(() =>{
							deferred.resolve();
						}, 0);
					}
				});
			} else {
				temp.push(location);
			}
		});

		if(!usingGeocoder) {
			setTimeout(() =>{
				deferred.resolve();
			}, 0);
		}

		return deferred.promise();
	},
	setLocation: function(location) {
		if (!this.map || !this.marker) return;

		const { onStart = () => {}, onFinish = () => {} } = location;

		onStart();

		const loc = $.extend({}, { lat: 41.902782, lng: 12.496366 }, location);
		this.map.setCenter(loc);
		this.marker.setPosition(loc);

		if(location.locations && location.locations.length > 0) {
			const locations = location.locations;
			const CONCURRENT_AMOUNT = 50;
			let i = 0;
			const slicedLocations = [];
			this.markers = [];

			while(i <= locations.length) {
				const slice = locations.slice(i, i + CONCURRENT_AMOUNT);

				slicedLocations.push(slice);
				i += CONCURRENT_AMOUNT;
			}

			slicedLocations
				.reduce((promise, location) => {
					return promise.then(() => {
						return this.calculateLocation(location);
					});
				}, $.when())
				.then(() => {
					if(!this.clusterer) {
						this.clusterer = new markerClusterer.MarkerClusterer({ markers: this.markers, map: this.map });
					}

					onFinish();
				});
		} else {
			onFinish();
		}
	}
});